import { List } from "react-native-paper";
import { LeaderboardListItem } from "./LeaderboardListItem";
import type { LeaderboardAvatarType, LeaderboardItem } from "./types";

type Props = {
	items: LeaderboardItem[];
	avatarType?: LeaderboardAvatarType;
};

export const LeaderboardList = ({ items, avatarType }: Props) => {
	return (
		<List.Section>
			{items.map((item) => (
				<LeaderboardListItem
					key={item.rank}
					{...item}
					avatarType={avatarType}
				/>
			))}
		</List.Section>
	);
};
